import VueIntercom from '@homebaseai/vue3-intercom'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueIntercom)
})
